import type { IconSvgProps, SvgContainerProps } from "./types";
import { createFromIconfontCN } from '@ant-design/icons';
import * as React from "react";

export const LogoIcon: React.FC<IconSvgProps> = ({
  size = 36,
  width,
  height,
  ...props
}) => (
  <svg
    fill="none"
    height={size || height}
    viewBox="0 0 32 32"
    width={size || width}
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M17.6482 10.1305L15.8785 7.02583L7.02979 22.5499H10.5278L17.6482 10.1305ZM19.8798 14.0457L18.11 17.1983L19.394 19.4511H16.8453L15.1056 22.5499H24.7272L19.8798 14.0457Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const DiscordIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        d="M14.82 4.26a10.14 10.14 0 0 0-.53 1.1 14.66 14.66 0 0 0-4.58 0 10.14 10.14 0 0 0-.53-1.1 16 16 0 0 0-4.13 1.3 17.33 17.33 0 0 0-3 11.59 16.6 16.6 0 0 0 5.07 2.59A12.89 12.89 0 0 0 8.23 18a9.65 9.65 0 0 1-1.71-.83 3.39 3.39 0 0 0 .42-.33 11.66 11.66 0 0 0 10.12 0q.21.18.42.33a10.84 10.84 0 0 1-1.71.84 12.41 12.41 0 0 0 1.08 1.78 16.44 16.44 0 0 0 5.06-2.59 17.22 17.22 0 0 0-3-11.59 16.09 16.09 0 0 0-4.09-1.35zM8.68 14.81a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.93 1.93 0 0 1 1.8 2 1.93 1.93 0 0 1-1.8 2zm6.64 0a1.94 1.94 0 0 1-1.8-2 1.93 1.93 0 0 1 1.8-2 1.92 1.92 0 0 1 1.8 2 1.92 1.92 0 0 1-1.8 2z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TwitterIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GithubIcon: React.FC<IconSvgProps> = ({
  size = 24,
  width,
  height,
  ...props
}) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const MoonFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
      fill="currentColor"
    />
  </svg>
);

export const SunFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <g fill="currentColor">
      <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
      <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
    </g>
  </svg>
);

export const HeartFilledIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const SearchIcon = (props: IconSvgProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="1em"
    role="presentation"
    viewBox="0 0 24 24"
    width="1em"
    {...props}
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22 22L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const NextUILogo: React.FC<IconSvgProps> = (props) => {
  const { width, height = 40 } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 161 32"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="fill-black dark:fill-white"
        d="M55.6827 5V26.6275H53.7794L41.1235 8.51665H40.9563V26.6275H39V5H40.89L53.5911 23.1323H53.7555V5H55.6827ZM67.4831 26.9663C66.1109 27.0019 64.7581 26.6329 63.5903 25.9044C62.4852 25.185 61.6054 24.1633 61.0537 22.9582C60.4354 21.5961 60.1298 20.1106 60.1598 18.6126C60.132 17.1113 60.4375 15.6228 61.0537 14.2563C61.5954 13.0511 62.4525 12.0179 63.5326 11.268C64.6166 10.5379 65.8958 10.16 67.1986 10.1852C68.0611 10.1837 68.9162 10.3468 69.7187 10.666C70.5398 10.9946 71.2829 11.4948 71.8992 12.1337C72.5764 12.8435 73.0985 13.6889 73.4318 14.6152C73.8311 15.7483 74.0226 16.9455 73.9968 18.1479V19.0773H63.2262V17.4194H72.0935C72.1083 16.4456 71.8952 15.4821 71.4714 14.6072C71.083 13.803 70.4874 13.1191 69.7472 12.6272C68.9887 12.1348 68.1022 11.8812 67.2006 11.8987C66.2411 11.8807 65.3005 12.1689 64.5128 12.7223C63.7332 13.2783 63.1083 14.0275 62.6984 14.8978C62.2582 15.8199 62.0314 16.831 62.0352 17.8546V18.8476C62.009 20.0078 62.2354 21.1595 62.6984 22.2217C63.1005 23.1349 63.7564 23.9108 64.5864 24.4554C65.4554 24.9973 66.4621 25.2717 67.4831 25.2448C68.1676 25.2588 68.848 25.1368 69.4859 24.8859C70.0301 24.6666 70.5242 24.3376 70.9382 23.919C71.3183 23.5345 71.6217 23.0799 71.8322 22.5799L73.5995 23.1604C73.3388 23.8697 72.9304 24.5143 72.4019 25.0506C71.8132 25.6529 71.1086 26.1269 70.3314 26.4434C69.4258 26.8068 68.4575 26.9846 67.4831 26.9663V26.9663ZM78.8233 10.4075L82.9655 17.325L87.1076 10.4075H89.2683L84.1008 18.5175L89.2683 26.6275H87.103L82.9608 19.9317L78.8193 26.6275H76.6647L81.7711 18.5169L76.6647 10.4062L78.8233 10.4075ZM99.5142 10.4075V12.0447H91.8413V10.4075H99.5142ZM94.2427 6.52397H96.1148V22.3931C96.086 22.9446 96.2051 23.4938 96.4597 23.9827C96.6652 24.344 96.9805 24.629 97.3589 24.7955C97.7328 24.9548 98.1349 25.0357 98.5407 25.0332C98.7508 25.0359 98.9607 25.02 99.168 24.9857C99.3422 24.954 99.4956 24.9205 99.6283 24.8853L100.026 26.5853C99.8062 26.6672 99.5805 26.7327 99.3511 26.7815C99.0274 26.847 98.6977 26.8771 98.3676 26.8712C97.6854 26.871 97.0119 26.7156 96.3973 26.4166C95.7683 26.1156 95.2317 25.6485 94.8442 25.0647C94.4214 24.4018 94.2097 23.6242 94.2374 22.8363L94.2427 6.52397ZM118.398 5H120.354V19.3204C120.376 20.7052 120.022 22.0697 119.328 23.2649C118.644 24.4235 117.658 25.3698 116.477 26.0001C115.168 26.6879 113.708 27.0311 112.232 26.9978C110.759 27.029 109.302 26.6835 107.996 25.9934C106.815 25.362 105.827 24.4161 105.141 23.2582C104.447 22.0651 104.092 20.7022 104.115 19.319V5H106.08V19.1831C106.061 20.2559 106.324 21.3147 106.843 22.2511C107.349 23.1459 108.094 23.8795 108.992 24.3683C109.993 24.9011 111.111 25.1664 112.242 25.139C113.373 25.1656 114.493 24.9003 115.495 24.3683C116.395 23.8815 117.14 23.1475 117.644 22.2511C118.16 21.3136 118.421 20.2553 118.402 19.1831L118.398 5ZM128 5V26.6275H126.041V5H128Z"
      />
      <path
        className="fill-black dark:fill-white"
        d="M23.5294 0H8.47059C3.79241 0 0 3.79241 0 8.47059V23.5294C0 28.2076 3.79241 32 8.47059 32H23.5294C28.2076 32 32 28.2076 32 23.5294V8.47059C32 3.79241 28.2076 0 23.5294 0Z"
      />
      <path
        className="fill-white dark:fill-black"
        d="M17.5667 9.21729H18.8111V18.2403C18.8255 19.1128 18.6 19.9726 18.159 20.7256C17.7241 21.4555 17.0968 22.0518 16.3458 22.4491C15.5717 22.8683 14.6722 23.0779 13.6473 23.0779C12.627 23.0779 11.7286 22.8672 10.9521 22.4457C10.2007 22.0478 9.5727 21.4518 9.13602 20.7223C8.6948 19.9705 8.4692 19.1118 8.48396 18.2403V9.21729H9.72854V18.1538C9.71656 18.8298 9.88417 19.4968 10.2143 20.0868C10.5362 20.6506 11.0099 21.1129 11.5814 21.421C12.1689 21.7448 12.8576 21.9067 13.6475 21.9067C14.4374 21.9067 15.1272 21.7448 15.7169 21.421C16.2895 21.1142 16.7635 20.6516 17.0844 20.0868C17.4124 19.4961 17.5788 18.8293 17.5667 18.1538V9.21729ZM23.6753 9.21729V22.845H22.4309V9.21729H23.6753Z"
      />
    </svg>
  );
};

export const SelectArrow: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3076_10614)">
        <path d="M6.6665 7.50008L9.99984 4.16675L13.3332 7.50008" stroke="#A1A1AA" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M13.3332 12.5L9.99984 15.8333L6.6665 12.5" stroke="#A1A1AA" strokeLinecap="round" strokeLinejoin="round"></path>
      </g>
      <defs>
        <clipPath id="clip0_3076_10614">
          <rect fill="white" height="20" width="20"></rect>
        </clipPath>
      </defs>
    </svg>
  )
}

export const PlanModel: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 1024 1024"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#EAF1FE" p-id="117642"></path>
      <path d="M531.2 246.6048l201.0368 116.0704a38.4 38.4 0 0 1 19.2 33.2544v232.1408a38.4 38.4 0 0 1-19.2 33.2544l-201.0368 116.0704a38.4 38.4 0 0 1-38.4 0l-201.0368-116.0704a38.4 38.4 0 0 1-19.2-33.2544v-232.1408a38.4 38.4 0 0 1 19.2-33.2544l201.0368-116.0704a38.4 38.4 0 0 1 38.4 0z m-19.2 33.28l-201.0368 116.0448v232.1408L512 744.1408l201.0368-116.0704v-232.1408L512 279.8592z m16.9728 127.3856l0.3072 112.8192 98.8672 56.704-19.5328 33.024-99.1744-56.832-100.608 58.88-20.6848-32.4608 102.7328-59.904v-112.2304h38.0928z" fill="#0054F0" p-id="117643"></path>
    </svg>
  )
}

export const Version: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 1024 1024"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#EFF2FF" p-id="83965"></path>
      <path d="M665.6 393.846154c-19.692308-3.938462-39.384615-3.938462-59.076923 7.876923-19.692308 7.876923-35.446154 19.692308-47.261539 31.507692-3.938462 7.876923-7.876923 11.815385-11.815384 19.692308-3.938462 7.876923 0 15.753846 7.876923 15.753846h3.938461c7.876923 0 15.753846 0 23.63077 7.876923 11.815385 11.815385 15.753846 27.569231 7.876923 43.323077-7.876923 19.692308-15.753846 35.446154-27.569231 55.138462-15.753846 19.692308-23.630769 27.569231-31.507692 31.507692-7.876923 3.938462-11.815385-3.938462-15.753846-11.815385-7.876923-15.753846-11.815385-31.507692-15.753847-47.261538-7.876923-27.569231-15.753846-70.892308-19.692307-98.461539 0-15.753846-7.876923-31.507692-15.753846-43.323077-7.876923-11.815385-23.630769-15.753846-35.446154-11.815384-23.630769 7.876923-43.323077 19.692308-59.076923 35.446154-15.753846 15.753846-31.507692 27.569231-47.261539 43.323077-3.938462 3.938462-3.938462 11.815385 0 15.753846 3.938462 3.938462 11.815385 7.876923 15.753846 3.938461 3.938462-3.938462 11.815385-3.938462 15.753846-7.876923 3.938462-3.938462 19.692308-11.815385 27.569231 7.876923s11.815385 43.323077 23.630769 78.769231c11.815385 43.323077 19.692308 63.015385 27.569231 86.646154 3.938462 19.692308 15.753846 39.384615 31.507693 55.138461 15.753846 11.815385 35.446154 15.753846 55.138461 7.876924 23.630769-15.753846 47.261538-35.446154 66.953846-55.138462 43.323077-39.384615 78.769231-90.584615 102.4-145.723077 15.753846-27.569231 19.692308-59.076923 15.753846-90.584615-3.938462-11.815385-19.692308-31.507692-39.384615-35.446154z" fill="#1687E8" p-id="172017"></path>
    </svg>
  )
}

export const UpdateDate: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 1024 1024"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#EFF2FF" p-id="77762"></path>
      <path d="M512 731.428571a219.428571 219.428571 0 1 0 0-438.857142 219.428571 219.428571 0 0 0 0 438.857142z m-93.915429-148.772571l77.458286-77.482667v-91.91619a16.457143 16.457143 0 0 1 32.914286 0V512c0 4.36419-1.731048 8.533333-4.827429 11.629714l-82.285714 82.285715a16.457143 16.457143 0 1 1-23.259429-23.259429z" fill="#4F6FFC" p-id="77763"></path>
    </svg>
  )
}

export const Analytics: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 1024 1024"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#FFD05B" p-id="154879"></path>
      <path d="M363.773465 174.586931v108.68594h-108.483168v566.140198h513.419406V174.586931z" fill="#FFFFFF" p-id="154880"></path>
      <path d="M363.773465 174.586931l-108.483168 108.68594h108.483168zM319.163564 596.758812H703.619802v29.604752H319.163564zM319.163564 659.009901H703.619802v29.604752H319.163564zM319.163564 721.26099h227.713268v29.604753H319.163564z" fill="#E6E9EE" p-id="154881"></path>
      <path d="M622.308119 416.291485c0 68.739802-55.762376 124.299406-124.299406 124.299406s-124.299406-55.762376-124.299406-124.299406c0-68.739802 55.762376-124.502178 124.299406-124.502178v124.502178h124.299406z" fill="#4CDBC4" p-id="154882"></path>
      <path d="M650.493465 388.106139h-124.299406V263.60396c68.53703 0.202772 124.299406 55.762376 124.299406 124.502179z" fill="#FF7058" p-id="154883"></path>
    </svg>
  )
}

export const Example: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 1024 1024"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M452.778667 109.653333L181.248 255.829333c-63.274667 34.005333-63.274667 106.026667 0 140.074667l271.530667 146.090667c45.952 24.704 115.2 24.704 161.109333 0l271.530667-146.090667c63.274667-34.048 63.274667-106.069333 0-140.074667L613.888 109.653333c-45.952-24.746667-115.2-24.746667-161.109333 0z" fill="#346FFF" p-id="191668"></path>
      <path d="M881.877333 474.453333a42.666667 42.666667 0 0 1 44.672 72.533334l-4.266666 2.56-301.653334 162.346666c-46.762667 25.173333-116.138667 26.624-165.546666 4.437334l-9.002667-4.437334-301.696-162.304a42.666667 42.666667 0 0 1 35.882667-77.269333l4.522666 2.133333 301.696 162.304c22.4 12.032 61.952 13.013333 87.168 2.986667l6.528-2.986667 301.653334-162.346666z" fill="#ADCDFF" p-id="191669"></path>
      <path d="M881.877333 645.12a42.666667 42.666667 0 0 1 44.672 72.533333l-4.266666 2.56-301.653334 162.346667c-46.762667 25.173333-116.138667 26.624-165.546666 4.437333l-9.002667-4.437333-301.696-162.304a42.666667 42.666667 0 0 1 35.882667-77.269333l4.522666 2.133333 301.696 162.304c22.4 12.032 61.952 13.013333 87.168 2.986667l6.528-2.986667 301.653334-162.346667z" fill="#ADCDFF" p-id="191670"></path>
    </svg>
  )
}

export const DatabaseIcon: React.FC<IconSvgProps> = (props) => {
  const { width, height = 20 } = props;
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 1024 1024"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M759.881143 637.805714l-14.628572-4.87619-9.752381-2.438095h-2.438095l-7.314285-4.876191c-19.504762 9.752381-41.447619 17.066667-63.390477 24.380952l9.752381 4.876191h2.438096l85.333333 36.571429 12.190476 4.87619v68.266667l146.285714 60.952381v-121.904762l-158.47619-65.828572z" fill="#49A9EE" p-id="211234"></path>
      <path d="M996.376381 628.053333c-4.87619 7.314286-9.752381 12.190476-14.628571 19.504762l-2.438096 2.438095-14.628571 14.628572-4.876191 4.87619c-4.87619 4.87619-9.752381 9.752381-17.066666 14.628572l-4.876191 4.87619c-7.314286 4.87619-14.628571 9.752381-24.380952 17.066667v119.466667c60.952381-36.571429 97.52381-82.895238 97.523809-134.095238v-119.466667c2.438095 19.504762-4.87619 39.009524-14.628571 56.07619" fill="#1F88D9" p-id="211235"></path>
      <path d="M1013.443048 562.224762c-2.438095-48.761905-39.009524-92.647619-97.52381-126.780952l-321.828571 134.095238 141.409523 58.514285 24.380953 9.752381 158.47619 65.828572c31.695238-17.066667 60.952381-43.885714 80.457143-75.580953 12.190476-17.066667 17.066667-39.009524 17.066667-58.514285-2.438095-2.438095-2.438095-4.87619-2.438095-7.314286" fill="#FFBF00" p-id="211236"></path>
      <path d="M1013.443048 472.015238v-7.314286c-2.438095-48.761905-39.009524-92.647619-97.52381-126.780952l-321.828571 134.095238 321.828571 134.095238c60.952381-36.571429 97.52381-82.895238 97.52381-134.095238" fill="#49A9EE" p-id="211237"></path>
      <path d="M915.919238 486.64381v119.466666c60.952381-36.571429 97.52381-82.895238 97.52381-134.095238v-119.466667c0 53.638095-36.571429 99.961905-97.52381 134.095239" fill="#1F88D9" p-id="211238"></path>
      <path d="M686.738286 391.558095l-70.704762-29.257143v109.714286h-24.380953l324.266667 134.095238v-119.466666z" fill="#49A9EE" p-id="211239"></path>
      <path d="M1013.443048 347.672381c-2.438095-43.885714-34.133333-85.333333-82.895238-119.466667l-170.666667 73.142857-143.847619 60.952381 70.704762 29.257143 229.180952 95.085715c60.952381-36.571429 97.52381-82.895238 97.52381-134.095239v-4.87619" fill="#FFBF00" p-id="211240"></path>
      <path d="M586.776381 415.939048v-73.142858l173.104762-73.142857v-51.2l-321.828572 136.533334z" fill="#49A9EE" p-id="211241"></path>
      <path d="M586.776381 415.939048l-148.72381-60.952381 321.828572-134.095238c-75.580952-46.32381-190.171429-73.142857-319.390476-73.142858-226.742857-2.438095-416.914286 87.771429-424.228572 199.92381v7.314286c0 114.590476 192.609524 209.67619 424.228572 209.67619 129.219048 0 243.809524-29.257143 319.390476-75.580952l-173.104762-73.142857zM635.538286 669.500952l-19.504762-7.314285-24.380953 4.87619c-51.2 9.752381-102.4 14.628571-153.6 14.628572-197.485714 0-365.714286-68.266667-412.038095-160.914286-7.314286 12.190476-9.752381 26.819048-12.190476 41.447619v7.314286c0 114.590476 192.609524 209.67619 424.228571 209.67619 90.209524 0 177.980952-14.628571 260.876191-46.323809 14.628571-4.87619 26.819048-12.190476 41.447619-19.504762l-104.838095-43.885715z" fill="#1F88D9" p-id="211242"></path>
      <path d="M733.062095 749.958095s0 2.438095 0 0z m7.314286-36.571428c-12.190476 7.314286-26.819048 12.190476-41.447619 19.504762-82.895238 31.695238-170.666667 46.32381-260.876191 46.323809-229.180952-2.438095-421.790476-95.085714-421.790476-209.67619v119.466666c0 114.590476 192.609524 209.67619 424.228572 209.676191 104.838095 2.438095 207.238095-19.504762 302.323809-63.390476l-2.438095-121.904762z" fill="#49A9EE" p-id="211243"></path>
      <path d="M759.881143 703.634286zM740.376381 749.958095v7.314286l9.752381-4.876191zM740.376381 749.958095l7.314286 2.438095-7.314286-2.438095zM750.128762 752.39619z" fill="#FFFFFF" p-id="211244"></path>
      <path d="M442.928762 562.224762h-2.438095c-151.161905 0-285.257143-41.447619-360.838096-99.961905-36.571429-24.380952-58.514286-63.390476-60.952381-107.27619v119.466666c0 17.066667 4.87619 34.133333 12.190477 48.761905 43.885714 92.647619 214.552381 160.914286 412.038095 160.914286 51.2 0 102.4-4.87619 153.6-14.628572l24.380952-4.87619c9.752381-2.438095 17.066667-4.87619 24.380953-7.314286l19.504762-4.87619c21.942857-7.314286 41.447619-14.628571 63.390476-24.380953 12.190476-4.87619 24.380952-12.190476 34.133333-17.066666v-119.466667c-78.019048 41.447619-192.609524 70.704762-319.390476 70.704762" fill="#49A9EE" p-id="211245"></path>
    </svg>
  )
}

export const PlusIcon: React.FC<IconSvgProps> = ({ size = 24, ...props }) => (
  <SvgWrapper size={size} {...props}>
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M6 12h12" />
      <path d="M12 18V6" />
    </g>
  </SvgWrapper>
);

export const VerticalDotsIcon = ({ size = 24, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height={size}
    role="presentation"
    viewBox="0 0 24 24"
    width={size}
    {...props}
  >
    <path
      d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      fill="currentColor"
    />
  </svg>
);

export const SvgWrapper: React.FC<SvgContainerProps> = (props) => {
  const { width, height, size = 20, children, ...otherProps } = props;
  return (
    <svg
      fill="none"
      height={height || size}
      viewBox="0 0 1024 1024"
      width={width || size}
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      {children}
    </svg>
  )
}

export const IconFont = createFromIconfontCN({
  scriptUrl: [
    "https://at.alicdn.com/t/c/font_4684468_04wsegzrbenx.js"
  ]
});